import React from 'react';
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Chip from "@material-ui/core/Chip";
import {makeStyles, createStyles} from "@material-ui/core/styles";

const RECEITA_SITUACOES = {
    1: { label: 'ATIVA', color: '#4caf50' },
    2: { label: 'ATIVA E NAO ACEITA NOVAS', color: '#ff9800' },
    3: { label: 'EM TESTE', color: '#2196f3' },
    4: { label: 'REPROVADA', color: '#f44336' },
    5: { label: 'NAO USAR, CAUSA ERRO', color: '#d32f2f' },
    6: { label: 'NOVA', color: '#9c27b0' },
};

const useStyles = makeStyles((theme) =>
    createStyles({
        cardPaper: {
            padding: theme.spacing(1.5),
            marginBottom: theme.spacing(1),
            border: '1px solid #e0e0e0',
        },
        paramLabel: {
            fontSize: '0.75rem',
            color: '#666',
        },
        paramValue: {
            fontSize: '0.85rem',
            fontWeight: 500,
        },
        statsLabel: {
            fontSize: '0.7rem',
            color: '#888',
        },
        statsValue: {
            fontSize: '0.8rem',
        },
        chipSituacao: {
            fontSize: '0.7rem',
            height: 22,
        },
        receitaId: {
            fontSize: '0.7rem',
            color: '#999',
        },
    })
);

const ParamItem = ({ label, value, classes }) => (
    <Grid item xs={4} sm={2}>
        <Typography className={classes.paramLabel}>{label}</Typography>
        <Typography className={classes.paramValue}>{value !== null && value !== undefined ? value : '-'}</Typography>
    </Grid>
);

const StatItem = ({ label, value, classes }) => (
    <Grid item xs={3} sm={2}>
        <Typography className={classes.statsLabel}>{label}</Typography>
        <Typography className={classes.statsValue}>{value || 0}</Typography>
    </Grid>
);

const GlbReceitaCard = ({ receita, onToggleAtivo }) => {
    const classes = useStyles();
    const situacao = RECEITA_SITUACOES[receita.glbRaspaReceitaSituacaoId] || { label: 'DESCONHECIDA', color: '#999' };
    const catId = receita.glbRaspaReceitaCategoriaId;
    const receitaLabel = (catId === 11 || catId === 12)
        ? receita.receitaMensagem || ''
        : receita.descricao || '';

    return (
        <Paper className={classes.cardPaper} variant="outlined">
            <Grid container spacing={1} alignItems="center">
                {/* ID + Descrição + Situação */}
                <Grid item xs={12} container alignItems="center" spacing={1}>
                    <Grid item>
                        <Typography className={classes.receitaId}>#{receita.id}</Typography>
                    </Grid>
                    {receitaLabel && (
                        <Grid item>
                            <Typography variant="body2" style={{ fontWeight: 500 }}>{receitaLabel}</Typography>
                        </Grid>
                    )}
                    <Grid item>
                        <Chip
                            label={situacao.label}
                            className={classes.chipSituacao}
                            style={{ backgroundColor: situacao.color, color: '#fff' }}
                            size="small"
                        />
                    </Grid>
                    <Grid item style={{ marginLeft: 'auto' }}>
                        <FormControlLabel
                            control={
                                <Switch
                                    size="small"
                                    checked={!!receita.ehAtivo}
                                    onChange={() => onToggleAtivo(receita.id, !receita.ehAtivo)}
                                    color="primary"
                                />
                            }
                            label={receita.ehAtivo ? "Ativo" : "Inativo"}
                        />
                    </Grid>
                </Grid>

                {/* Parâmetros */}
                <ParamItem label="Larg. Rasp." value={receita.larguraRaspagem} classes={classes} />
                <ParamItem label="Raio Rasp." value={receita.raioRaspagem} classes={classes} />
                <ParamItem label="Perímetro" value={receita.perimetro} classes={classes} />
                <ParamItem label="Âng. Ombro" value={receita.anguloOmbro} classes={classes} />
                <ParamItem label="Comp. Ombro" value={receita.comprimentoOmbro} classes={classes} />
                <ParamItem label="Raio Ombro" value={receita.raioOmbro} classes={classes} />

                {/* Estatísticas */}
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        <StatItem label="Raspagens" value={receita.contadorRaspagens} classes={classes} />
                        <StatItem label="Bons" value={receita.contadorPneusBons} classes={classes} />
                        <StatItem label="Regular" value={receita.contadorPneusRegular} classes={classes} />
                        <StatItem label="Ruins" value={receita.contadorPneusRuins} classes={classes} />
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default GlbReceitaCard;
